export enum TypeReleveConsoEnum {
  TYPE_RELEVE_COMPTEUR = 'TYPE_RELEVE_COMPTEUR',
  TYPE_RELEVE_FACTURE_INDEX_RELEVE = 'TYPE_RELEVE_FACTURE_INDEX_RELEVE',
  TYPE_RELEVE_FACTURE_INDEX_ESTIME = 'TYPE_RELEVE_FACTURE_INDEX_ESTIME',
}
